/* tslint:disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v10.5.6320.21856 (NJsonSchema v8.32.6319.16936) (http://NSwag.org)
// </auto-generated>
//----------------------

import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/catch';

import { Observable } from 'rxjs/Observable';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { Http, Headers, ResponseContentType, Response } from '@angular/http';
import { HydrogenAppConfigService } from '../host.config.service';

export const API_BASE_URL = new InjectionToken('API_BASE_URL');

@Injectable()
export class ActivityLogApiService {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(configSvc: HydrogenAppConfigService, @Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = configSvc.config.serviceUrl.activitylog;
    }

    getActivityLogs(search: ActivityLogSearch): Observable<ActivityLogResponse> {
        let url_ = this.baseUrl + "/api/activitylog/many";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(search);

        let options_ = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_) => {
            return this.processGetActivityLogs(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetActivityLogs(response_);
                } catch (e) {
                    return <Observable<ActivityLogResponse>><any>Observable.throw(e);
                }
            } else
                return <Observable<ActivityLogResponse>><any>Observable.throw(response_);
        });
    }

    protected processGetActivityLogs(response: Response): Observable<ActivityLogResponse> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ActivityLogResponse.fromJS(resultData200) : <any>null;
            return Observable.of(result200);
        } else if (status === 500) {
            const _responseText = response.text();
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
            return throwException("A server error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ActivityLogResponse>(<any>null);
    }

    getDownloadActivitylogs(accountId: string, groupId: string, deviceId: string, deviceModelType: string, languageCode: string): Observable<string> {
        let url_ = this.baseUrl + "/api/activitylog?";
        if (accountId === undefined)
            throw new Error("The parameter 'accountId' must be defined.");
        else
            url_ += "AccountId=" + encodeURIComponent("" + accountId) + "&";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined and cannot be null.");
        else
            url_ += "GroupId=" + encodeURIComponent("" + groupId) + "&";
        if (deviceId === undefined)
            throw new Error("The parameter 'deviceId' must be defined.");
        else
            url_ += "DeviceId=" + encodeURIComponent("" + deviceId) + "&";
        if (deviceModelType === undefined)
            throw new Error("The parameter 'deviceModelType' must be defined.");
        else
            url_ += "deviceModelType=" + encodeURIComponent("" + deviceModelType) + "&";
        if (languageCode === undefined)
            throw new Error("The parameter 'languageCode' must be defined.");
        else
            url_ += "languageCode=" + encodeURIComponent("" + languageCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_) => {
            return this.processGetDownloadActivitylogs(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDownloadActivitylogs(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetDownloadActivitylogs(response: Response): Observable<string> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status === 400) {
            const _responseText = response.text();
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? CustomError.fromJS(resultData400) : <any>null;
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    activityLog_Put(id: number, value: string): Observable<void> {
        let url_ = this.baseUrl + "/api/activitylog?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_ = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };

        return this.http.request(url_, options_).flatMap((response_) => {
            return this.processActivityLog_Put(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processActivityLog_Put(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processActivityLog_Put(response: Response): Observable<void> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 204) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    activityLog_Delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/activitylog?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };

        return this.http.request(url_, options_).flatMap((response_) => {
            return this.processActivityLog_Delete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processActivityLog_Delete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processActivityLog_Delete(response: Response): Observable<void> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 204) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    createActivityLogCollection(activityLogs: ActivityLog2[]): Observable<boolean> {
        let url_ = this.baseUrl + "/api/activitylog/createCollection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(activityLogs);

        let options_ = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_) => {
            return this.processCreateActivityLogCollection(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateActivityLogCollection(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processCreateActivityLogCollection(response: Response): Observable<boolean> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status === 500) {
            const _responseText = response.text();
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
            return throwException("A server error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    createActivityLog(activityLog: ActivityLog2): Observable<boolean> {
        let url_ = this.baseUrl + "/api/activitylog/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(activityLog);

        let options_ = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_) => {
            return this.processCreateActivityLog(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateActivityLog(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processCreateActivityLog(response: Response): Observable<boolean> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status === 500) {
            const _responseText = response.text();
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
            return throwException("A server error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }
}

export class ActivityLogSearch implements IActivityLogSearch {
    accountId?: string;
    deviceCid?: string;
    groupId?: string;
    isShowOnlyGroup: boolean;
    deviceModelType?: string;
    searchCriteria?: string;
    sortCriteria?: string;
    sortDirection?: string;
    startDate?: Date;
    endDate?: Date;
    page?: number;
    pageSize?: number;
    languageCode?: string;

    constructor(data?: IActivityLogSearch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accountId = data["AccountId"] !== undefined ? data["AccountId"] : <any>null;
            this.deviceCid = data["DeviceCid"] !== undefined ? data["DeviceCid"] : <any>null;
            this.groupId = data["GroupId"] !== undefined ? data["GroupId"] : <any>null;
            this.isShowOnlyGroup = data["isShowOnlyGroup"] !== undefined ? data["isShowOnlyGroup"] : <any>null;
            this.deviceModelType = data["DeviceModelType"] !== undefined ? data["DeviceModelType"] : <any>null;
            this.searchCriteria = data["searchCriteria"] !== undefined ? data["searchCriteria"] : <any>null;
            this.sortCriteria = data["SortCriteria"] !== undefined ? data["SortCriteria"] : <any>null;
            this.sortDirection = data["sortDirection"] !== undefined ? data["sortDirection"] : <any>null;
            this.startDate = data["startDate"] ? new Date(data["startDate"].toString()) : <any>null;
            this.endDate = data["endDate"] ? new Date(data["endDate"].toString()) : <any>null;
            this.page = data["Page"] !== undefined ? data["Page"] : <any>null;
            this.pageSize = data["PageSize"] !== undefined ? data["PageSize"] : <any>null;
            this.languageCode = data["languageCode"] !== undefined ? data["languageCode"] : <any>null;
        }
    }

    static fromJS(data: any): ActivityLogSearch {
        let result = new ActivityLogSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AccountId"] = this.accountId !== undefined ? this.accountId : <any>null;
        data["DeviceCid"] = this.deviceCid !== undefined ? this.deviceCid : <any>null;
        data["GroupId"] = this.groupId !== undefined ? this.groupId : <any>null;
        data["isShowOnlyGroup"] = this.isShowOnlyGroup !== undefined ? this.isShowOnlyGroup : <any>null;
        data["DeviceModelType"] = this.deviceModelType !== undefined ? this.deviceModelType : <any>null;
        data["searchCriteria"] = this.searchCriteria !== undefined ? this.searchCriteria : <any>null;
        data["SortCriteria"] = this.sortCriteria !== undefined ? this.sortCriteria : <any>null;
        data["sortDirection"] = this.sortDirection !== undefined ? this.sortDirection : <any>null;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>null;
        data["Page"] = this.page !== undefined ? this.page : <any>null;
        data["PageSize"] = this.pageSize !== undefined ? this.pageSize : <any>null;
        data["languageCode"] = this.languageCode !== undefined ? this.languageCode : <any>null;
        return data;
    }
}

export interface IActivityLogSearch {
    accountId?: string;
    deviceCid?: string;
    groupId?: string;
    isShowOnlyGroup: boolean;
    deviceModelType?: string;
    searchCriteria?: string;
    sortCriteria?: string;
    sortDirection?: string;
    startDate?: Date;
    endDate?: Date;
    page?: number;
    pageSize?: number;
    languageCode?: string;
}

export class ActivityLogResponse implements IActivityLogResponse {
    totalRecords: number;
    activitylogs?: ActivityLog[];

    constructor(data?: IActivityLogResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalRecords = data["totalRecords"] !== undefined ? data["totalRecords"] : <any>null;
            if (data["activitylogs"] && data["activitylogs"].constructor === Array) {
                this.activitylogs = [];
                for (let item of data["activitylogs"])
                    this.activitylogs.push(ActivityLog.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActivityLogResponse {
        let result = new ActivityLogResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords !== undefined ? this.totalRecords : <any>null;
        if (this.activitylogs && this.activitylogs.constructor === Array) {
            data["activitylogs"] = [];
            for (let item of this.activitylogs)
                data["activitylogs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IActivityLogResponse {
    totalRecords: number;
    activitylogs?: ActivityLog[];
}

export class ActivityLog implements IActivityLog {
    id: string;
    accountId?: string;
    objectId?: string;
    objectName?: string;
    deviceModelType?: string;
    created: Date;
    correlationId: string;
    userId?: string;
    userName?: string;
    logType: ActivityLogType;
    targetObject?: string;
    property?: string;
    originalValue?: any;
    updatedValue?: any;
    actualValue?: any;
    displayedValue?: string;
    snapshottedObject?: any;

    constructor(data?: IActivityLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.accountId = data["AccountId"] !== undefined ? data["AccountId"] : <any>null;
            this.objectId = data["ObjectId"] !== undefined ? data["ObjectId"] : <any>null;
            this.objectName = data["ObjectName"] !== undefined ? data["ObjectName"] : <any>null;
            this.deviceModelType = data["DeviceModelType"] !== undefined ? data["DeviceModelType"] : <any>null;
            this.created = data["Created"] ? new Date(data["Created"].toString()) : <any>null;
            this.correlationId = data["CorrelationId"] !== undefined ? data["CorrelationId"] : <any>null;
            this.userId = data["UserId"] !== undefined ? data["UserId"] : <any>null;
            this.userName = data["UserName"] !== undefined ? data["UserName"] : <any>null;
            this.logType = data["LogType"] !== undefined ? data["LogType"] : <any>null;
            this.targetObject = data["TargetObject"] !== undefined ? data["TargetObject"] : <any>null;
            this.property = data["Property"] !== undefined ? data["Property"] : <any>null;
            this.originalValue = data["OriginalValue"] !== undefined ? data["OriginalValue"] : <any>null;
            this.updatedValue = data["UpdatedValue"] !== undefined ? data["UpdatedValue"] : <any>null;
            this.actualValue = data["ActualValue"] !== undefined ? data["ActualValue"] : <any>null;
            this.displayedValue = data["DisplayedValue"] !== undefined ? data["DisplayedValue"] : <any>null;
            this.snapshottedObject = data["SnapshottedObject"] !== undefined ? data["SnapshottedObject"] : <any>null;
        }
    }

    static fromJS(data: any): ActivityLog {
        let result = new ActivityLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["AccountId"] = this.accountId !== undefined ? this.accountId : <any>null;
        data["ObjectId"] = this.objectId !== undefined ? this.objectId : <any>null;
        data["ObjectName"] = this.objectName !== undefined ? this.objectName : <any>null;
        data["DeviceModelType"] = this.deviceModelType !== undefined ? this.deviceModelType : <any>null;
        data["Created"] = this.created ? this.created.toISOString() : <any>null;
        data["CorrelationId"] = this.correlationId !== undefined ? this.correlationId : <any>null;
        data["UserId"] = this.userId !== undefined ? this.userId : <any>null;
        data["UserName"] = this.userName !== undefined ? this.userName : <any>null;
        data["LogType"] = this.logType !== undefined ? this.logType : <any>null;
        data["TargetObject"] = this.targetObject !== undefined ? this.targetObject : <any>null;
        data["Property"] = this.property !== undefined ? this.property : <any>null;
        data["OriginalValue"] = this.originalValue !== undefined ? this.originalValue : <any>null;
        data["UpdatedValue"] = this.updatedValue !== undefined ? this.updatedValue : <any>null;
        data["ActualValue"] = this.actualValue !== undefined ? this.actualValue : <any>null;
        data["DisplayedValue"] = this.displayedValue !== undefined ? this.displayedValue : <any>null;
        data["SnapshottedObject"] = this.snapshottedObject !== undefined ? this.snapshottedObject : <any>null;
        return data;
    }
}

export interface IActivityLog {
    id: string;
    accountId?: string;
    objectId?: string;
    objectName?: string;
    deviceModelType?: string;
    created: Date;
    correlationId: string;
    userId?: string;
    userName?: string;
    logType: ActivityLogType;
    targetObject?: string;
    property?: string;
    originalValue?: any;
    updatedValue?: any;
    actualValue?: any;
    displayedValue?: string;
    snapshottedObject?: any;
}

export enum ActivityLogType {
    Device = 0,
    Group = 1,
    License = 2,
    Firmware = 3,
}

export class CustomError implements ICustomError {
    severity: SeverityEnum;
    statusCode: HttpStatusCode;
    correlationId?: string;
    message?: string;
    exceptionType?: string;

    constructor(data?: ICustomError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.severity = data["Severity"] !== undefined ? data["Severity"] : <any>null;
            this.statusCode = data["StatusCode"] !== undefined ? data["StatusCode"] : <any>null;
            this.correlationId = data["CorrelationId"] !== undefined ? data["CorrelationId"] : <any>null;
            this.message = data["Message"] !== undefined ? data["Message"] : <any>null;
            this.exceptionType = data["ExceptionType"] !== undefined ? data["ExceptionType"] : <any>null;
        }
    }

    static fromJS(data: any): CustomError {
        let result = new CustomError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Severity"] = this.severity !== undefined ? this.severity : <any>null;
        data["StatusCode"] = this.statusCode !== undefined ? this.statusCode : <any>null;
        data["CorrelationId"] = this.correlationId !== undefined ? this.correlationId : <any>null;
        data["Message"] = this.message !== undefined ? this.message : <any>null;
        data["ExceptionType"] = this.exceptionType !== undefined ? this.exceptionType : <any>null;
        return data;
    }
}

export interface ICustomError {
    severity: SeverityEnum;
    statusCode: HttpStatusCode;
    correlationId?: string;
    message?: string;
    exceptionType?: string;
}

export enum SeverityEnum {
    None = 0,
    Warning = 1,
    Error = 2,
    Exception = 3,
}

export enum HttpStatusCode {
    Continue = 100,
    SwitchingProtocols = 101,
    OK = 200,
    Created = 201,
    Accepted = 202,
    NonAuthoritativeInformation = 203,
    NoContent = 204,
    ResetContent = 205,
    PartialContent = 206,
    MultipleChoices = 300,
    Ambiguous = 300,
    MovedPermanently = 301,
    Moved = 301,
    Found = 302,
    Redirect = 302,
    SeeOther = 303,
    RedirectMethod = 303,
    NotModified = 304,
    UseProxy = 305,
    Unused = 306,
    TemporaryRedirect = 307,
    RedirectKeepVerb = 307,
    BadRequest = 400,
    Unauthorized = 401,
    PaymentRequired = 402,
    Forbidden = 403,
    NotFound = 404,
    MethodNotAllowed = 405,
    NotAcceptable = 406,
    ProxyAuthenticationRequired = 407,
    RequestTimeout = 408,
    Conflict = 409,
    Gone = 410,
    LengthRequired = 411,
    PreconditionFailed = 412,
    RequestEntityTooLarge = 413,
    RequestUriTooLong = 414,
    UnsupportedMediaType = 415,
    RequestedRangeNotSatisfiable = 416,
    ExpectationFailed = 417,
    UpgradeRequired = 426,
    InternalServerError = 500,
    NotImplemented = 501,
    BadGateway = 502,
    ServiceUnavailable = 503,
    GatewayTimeout = 504,
    HttpVersionNotSupported = 505,
}

export class ActivityLog2 implements IActivityLog2 {
    id: string;
    accountId?: string;
    objectId?: string;
    objectName?: string;
    deviceModelType?: string;
    created: Date;
    correlationId: string;
    userId?: string;
    userName?: string;
    logType: ActivityLogType2;
    targetObject?: string;
    property?: string;
    originalValue?: any;
    updatedValue?: any;
    actualValue?: any;
    displayedValue?: string;
    snapshottedObject?: any;

    constructor(data?: IActivityLog2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.accountId = data["AccountId"] !== undefined ? data["AccountId"] : <any>null;
            this.objectId = data["ObjectId"] !== undefined ? data["ObjectId"] : <any>null;
            this.objectName = data["ObjectName"] !== undefined ? data["ObjectName"] : <any>null;
            this.deviceModelType = data["DeviceModelType"] !== undefined ? data["DeviceModelType"] : <any>null;
            this.created = data["Created"] ? new Date(data["Created"].toString()) : <any>null;
            this.correlationId = data["CorrelationId"] !== undefined ? data["CorrelationId"] : <any>null;
            this.userId = data["UserId"] !== undefined ? data["UserId"] : <any>null;
            this.userName = data["UserName"] !== undefined ? data["UserName"] : <any>null;
            this.logType = data["LogType"] !== undefined ? data["LogType"] : <any>null;
            this.targetObject = data["TargetObject"] !== undefined ? data["TargetObject"] : <any>null;
            this.property = data["Property"] !== undefined ? data["Property"] : <any>null;
            this.originalValue = data["OriginalValue"] !== undefined ? data["OriginalValue"] : <any>null;
            this.updatedValue = data["UpdatedValue"] !== undefined ? data["UpdatedValue"] : <any>null;
            this.actualValue = data["ActualValue"] !== undefined ? data["ActualValue"] : <any>null;
            this.displayedValue = data["DisplayedValue"] !== undefined ? data["DisplayedValue"] : <any>null;
            this.snapshottedObject = data["SnapshottedObject"] !== undefined ? data["SnapshottedObject"] : <any>null;
        }
    }

    static fromJS(data: any): ActivityLog2 {
        let result = new ActivityLog2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["AccountId"] = this.accountId !== undefined ? this.accountId : <any>null;
        data["ObjectId"] = this.objectId !== undefined ? this.objectId : <any>null;
        data["ObjectName"] = this.objectName !== undefined ? this.objectName : <any>null;
        data["DeviceModelType"] = this.deviceModelType !== undefined ? this.deviceModelType : <any>null;
        data["Created"] = this.created ? this.created.toISOString() : <any>null;
        data["CorrelationId"] = this.correlationId !== undefined ? this.correlationId : <any>null;
        data["UserId"] = this.userId !== undefined ? this.userId : <any>null;
        data["UserName"] = this.userName !== undefined ? this.userName : <any>null;
        data["LogType"] = this.logType !== undefined ? this.logType : <any>null;
        data["TargetObject"] = this.targetObject !== undefined ? this.targetObject : <any>null;
        data["Property"] = this.property !== undefined ? this.property : <any>null;
        data["OriginalValue"] = this.originalValue !== undefined ? this.originalValue : <any>null;
        data["UpdatedValue"] = this.updatedValue !== undefined ? this.updatedValue : <any>null;
        data["ActualValue"] = this.actualValue !== undefined ? this.actualValue : <any>null;
        data["DisplayedValue"] = this.displayedValue !== undefined ? this.displayedValue : <any>null;
        data["SnapshottedObject"] = this.snapshottedObject !== undefined ? this.snapshottedObject : <any>null;
        return data;
    }
}

export interface IActivityLog2 {
    id: string;
    accountId?: string;
    objectId?: string;
    objectName?: string;
    deviceModelType?: string;
    created: Date;
    correlationId: string;
    userId?: string;
    userName?: string;
    logType: ActivityLogType2;
    targetObject?: string;
    property?: string;
    originalValue?: any;
    updatedValue?: any;
    actualValue?: any;
    displayedValue?: string;
    snapshottedObject?: any;
}

export enum ActivityLogType2 {
    Device = 0,
    Group = 1,
    License = 2,
    Firmware = 3,
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return Observable.throw(result);
    else
        return Observable.throw(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        let reader = new FileReader();
        reader.onload = function () {
            observer.next(this.result);
            observer.complete();
        }
        reader.readAsText(blob);
    });
}


// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/services/Crestron.HydrogenAPI.ActivityLogApi.service.ts